import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const MeetCenia = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].meet;
  return <FadeInSection id="about" className="w-full bg-[#f8f4ef]" data-id="element-169">
      <div className="flex flex-col lg:flex-row w-full min-h-[800px]" data-id="element-170">
        {/* Left: Image */}
        <div className="w-full lg:w-1/2 h-[500px] lg:h-auto relative" data-id="element-171">
          <img src="https://cdn.magicpatterns.com/uploads/5VnyT84TQYuMgcqFXXF2nk/Cenia_centrada.png" alt="Cenia Badillo" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-172" />
        </div>

        {/* Right: Content */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 py-20 lg:px-24 xl:px-32" data-id="element-173">
          <span className="eyebrow mb-4" data-id="element-174">{t.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl uppercase tracking-wider text-[#1a1a1a] mb-8" data-id="element-175">
            {t.headline}
          </h2>

          <div className="w-[60px] h-px bg-[#c9a96e] mb-10" data-id="element-176" />

          <div className="space-y-8" data-id="element-177">
            <p className="body-text text-lg text-[#1a1a1a]/80" data-id="element-178">{t.body1}</p>
            <p className="body-text text-lg text-[#1a1a1a]/60 italic font-light" data-id="element-179">
              {t.body2}
            </p>
          </div>

          <div className="mt-12" data-id="element-180">
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-10 py-4 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-sm hover:bg-[#c9a96e] hover:text-white transition-colors duration-300" data-id="element-181">
              {t.cta}
            </button>
          </div>
        </div>
      </div>
    </FadeInSection>;
};